import { memo } from 'react'
import { Sessions } from '../../types/Sessions'
import { SheetHeaderActions } from '../sheet/SheetHeaderActions'
import { File, FileTabs } from './FileTabs'
import { DefaultActions } from './HeaderActions/DefaultActions'
import { UploadActions } from './HeaderActions/UploadActions'
import { SessionsDropdown } from './SessionsDropdown'

export interface Artifact {
  id: string
  name: string
  type:
    | 'file_analysis'
    | 'validation_report'
    | 'transformation_log'
    | 'custom'
    | 'report'
  fileId?: string
  sheetId?: string
  data: any
}

interface HeaderProps {
  sessions?: Sessions
  files?: File[]
  artifacts?: Artifact[]
  isUploading?: boolean
  onRenameFile?: (fileId: string, newName: string) => Promise<void>
}

const HeaderActions = memo(
  ({
    isUploading,
    sessions,
  }: {
    isUploading?: boolean
    sessions?: Sessions
  }) => {
    if (isUploading) return <UploadActions />
    if (sessions && sessions.length > 0) return <SheetHeaderActions />
    return <DefaultActions />
  }
)

HeaderActions.displayName = 'HeaderActions'

const Header = ({
  sessions,
  files,
  artifacts,
  isUploading,
  onRenameFile,
}: HeaderProps): any => {
  return (
    <header className='flex justify-between px-6 border-b bg-background-80 z-10 sticky top-0 h-12 w-full'>
      <div className='flex shrink-0 gap-4'>
        {sessions && sessions.length > 0 && (
          <SessionsDropdown sessions={sessions} />
        )}
      </div>
      <div className='relative flex-1 mx-4 h-full'>
        <div className='absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-background-80 via-background-80/50 to-transparent z-10 pointer-events-none' />
        <div className='absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-background-80 via-background-80/50 to-transparent z-10 pointer-events-none' />
        <div className='absolute inset-0 flex items-center'>
          <div className='w-full overflow-x-auto overflow-y-visible [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]'>
            {(files || artifacts) && (
              <div className='flex gap-2 min-w-min'>
                <FileTabs
                  files={files}
                  artifacts={artifacts}
                  // onRename={onRenameFile || (() => Promise.resolve())}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='flex items-center gap-4 h-full shrink-0'>
        <HeaderActions isUploading={!!isUploading} sessions={sessions} />
      </div>
    </header>
  )
}

export default Header
